import { MenuItem, Select, Stack, TextField } from "@mui/material";
import { Controller, RegisterOptions, UseFormReturn, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FiltersFormValues } from "..";
import { FilterDTO } from "../../../../../../../../../../datasources/api-client/data-contracts";

type Props = {
	item: FilterDTO;
	index: number;
	form: UseFormReturn<FiltersFormValues>;
	rules?: RegisterOptions<FiltersFormValues, any>;
};

export const FilterText = ({ item, index, form, rules }: Props) => {
	const { t } = useTranslation("common");
	const { control, setValue } = form;

	const isRequired = !!rules?.required;

	// watch operator to determine if value field should be shown/required
	const currentOperator = useWatch({
		control,
		name: `filters.${index}.operator`,
	});

	// find selected operator details
	// check args type to know if value input should be shown
	const selectedOperator = item.operators?.find((o: any) => o.operator === currentOperator) ?? item.operators?.[0];

	// show value field if operator requires an argument
	const showValue = selectedOperator?.argsType !== "none";

	return (
		<Stack direction="row" spacing={2} alignItems="center">
			{/* label */}
			<TextField value={item.label} className="read-only" size="small" sx={{ flex: 1 }} />

			{/* operator */}
			<Controller
				name={`filters.${index}.operator`}
				control={control}
				render={({ field }) => (
					<Select
						size="small"
						value={field.value ?? ""}
						sx={{ flex: 1 }}
						onChange={(e) => {
							field.onChange(e.target.value);
							setValue(`filters.${index}.value`, "");
						}}
					>
						{item.operators?.map((op: any) => (
							<MenuItem key={op.operator} value={op.operator}>
								{op.label}
							</MenuItem>
						))}
					</Select>
				)}
			/>

			{/* value */}
			<Controller
				name={`filters.${index}.value`}
				control={control}
				rules={rules}
				render={({ field, fieldState }) => (
					<TextField
						{...field}
						size="small"
						disabled={!showValue}
						label={isRequired ? `${t("value")} *` : t("value")}
						error={!!fieldState.error}
						helperText={fieldState.error?.message}
						sx={{ flex: 1 }}
					/>
				)}
			/>
		</Stack>
	);
};
